export const KLIVING_LOGO = "https://customer-assets-v7afamib.emergentagent.net/job_56c33da6-1d71-44e9-a0b0-c8b0d627c6dc/artifacts/irw8xvxl_kliving.png";

export default function Logo({ variant = "dark", className = "", size = 42 }) {
  const invert = variant === "light" ? "brightness-0 invert" : "";
  return (
    <div className={`inline-flex items-center ${className}`}>
      <img
        src={KLIVING_LOGO}
        alt="KLiving"
        style={{ height: size, width: "auto" }}
        className={`object-contain ${invert}`}
      />
    </div>
  );
}
